export default function ({ route, redirect }) {

  if (
    route.path === '/acties/wk-darts' ||
    route.path.startsWith('/acties/wk-darts/')
    ) {
    redirect('/sexfilms/wk-darts-finale');
  return;
}

if (
  route.path === '/acties/valentijn-festijn' ||
  route.path.startsWith('/acties/valentijn-festijn/')
  ) {
  redirect('/?ended=valentijn-festijn');
return;
}

  // Redirect /chicas-de-holanda to /acties/chicas-de-holanda
if (route.path === '/chicas-de-holanda' || route.path.startsWith('/chicas-de-holanda/')) {
  const suffix = route.path.replace('/chicas-de-holanda', '');
  redirect(`/acties/chicas-de-holanda${suffix}`);
  return;
}
if (route.path === '/all-in' || route.path.startsWith('/all-in/')) {
  const suffix = route.path.replace('/all-in', '');
  redirect(`/acties/all-in${suffix}`);
  return;
}
if (route.path === '/series/kim-holland-verrast') {
  redirect(`/modellen/kim-holland`);
  return;
}
if (route.path === '/onze-tip-zo-kijk-je-goedkoop-elke-dag-sexfilms') {
  redirect(`/direct?paywall=active`);
  return;
}

  // Existing redirect for /categorieen and /programmas
const pathMatch = route.path.match(/^\/(?:categorieen|programmas)(?:\/([\w-]+))?$/);
if (pathMatch) {
  const slug = pathMatch[1];
  const newPath = route.path.includes('categorieen')
  ? slug
  ? `/genres/${slug}`
  : '/genres'
  : slug
  ? `/series/${slug}`
  : '/series';
  redirect(newPath);
}
}
